module.exports = __webpack_public_path__ + "img/premios.a668aefa.jpg";